import { render, staticRenderFns } from "./MainDefaultNews.vue?vue&type=template&id=69b6705a&scoped=true&"
import script from "./MainDefaultNews.vue?vue&type=script&lang=js&"
export * from "./MainDefaultNews.vue?vue&type=script&lang=js&"
import style0 from "./MainDefaultNews.vue?vue&type=style&index=0&id=69b6705a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b6705a",
  null
  
)

export default component.exports